import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import CouponList from '../CouponList'
import Modal from '../Modal/Modal'
import AppliedCouponView from '../AppliedCouponView/AppliedCouponView'
import { handleCoupon } from '../../Utils/constants'
import styles from './ApplyCouponView.module.css'

const ApplyCouponView = ({cartVal, couponsError, setDrawerOpen, coupons, couponsLoading, ogvalues, DataStore, coinsValue, params, handleCouponCodeResponse, setCouponDetails, setModalOpen, setApplyCouponErr, applyCouponErr, token, setApplyCouponLoading,
  applyCouponLoading}) => {
    // const [modalOpen, setModalOpen] = useState(false);
    // const [couponDetails, setCouponDetails] = useState(null);
    const [couponCodeVal, setCouponCodeVal] = useState('');



    const [parentValues, setParentValues] = useState()

    // {ogvalues: ogvalues, DataStore: DataStore, coinsValue: coinsValue}

    useEffect(() => {
      setParentValues({
          ogvalues: ogvalues,
          DataStore: DataStore,
          coinsValue: coinsValue,
      });
  }, [ogvalues, DataStore, coinsValue]); // Run effect when these values change
  

    
    useEffect(() => setApplyCouponErr(null) ,[])


    const handleApplyCoupon = async() => {

      console.log("In coupon params", params)
      // couponcode,
      // amountforcoupon,
      // planidforcoupon,
      // ogvalues,
      // DataStore,
      // coinsValue

      setApplyCouponErr(null)
      setApplyCouponLoading(true)
      window.scrollTo(0,0);
      

      setTimeout(() => setModalOpen(true), 0);

     const res = await handleCoupon(couponCodeVal, null, DataStore?.planid, ogvalues, DataStore, coinsValue, params, token)

    //  alert(JSON.stringify(res?.data?.couponDetails[0]));

      if(!res?.data?.notFoundErr)
        handleCouponCodeResponse(res);

     console.log("Apply coupon res --> ", res);
     
      if(!res?.error) {
        if(res?.data?.couponDetails) {
          setCouponDetails(res?.data?.couponDetails[0]);
          setTimeout(() => setModalOpen(true), 0);
          setDrawerOpen(false);
        }
      }

      if(res?.data?.errMessage) {
        console.log("in apply coupon view component", res?.data?.errMessage)
        // setApplyCouponErr("TEST")
        setApplyCouponErr(res?.data?.errMessage)
        setTimeout(() => setModalOpen(false), 0);
        window.scrollTo(0, document.body.scrollHeight);
      }

      if(res?.notFoundErr === false) {
        setApplyCouponLoading(false);
        console.log("in apply coupon view component", res?.data?.errMessage)
        // setApplyCouponErr("TEST")
        setApplyCouponErr("Some error occurred")
        setTimeout(() => setModalOpen(false), 0);
        window.scrollTo(0, document.body.scrollHeight);
      }

      setApplyCouponLoading(false);
  }

  useEffect(() => {
    return () => setModalOpen(false);
  },[])



  return (
    <>
    <div className='applyCouponView'>
        <div className='couponViewHeader'>
            <div className='couponHeaderTop'>
                <button className='cursor_pointer' onClick={() => setDrawerOpen(false)}><FontAwesomeIcon icon={faArrowLeft} /></button>
                <div>
                    <p>APPLY COUPON</p>
                    {/* <p className='cartVal'>Your cart: <span>{cartVal}</span></p> */}
                </div>
            </div>
            <div className='search'>
                    <input type='text' onChange={(e) => setCouponCodeVal(e?.target?.value)} value={couponCodeVal} placeholder='Enter Coupon Code'></input>
                    <button disabled={couponCodeVal?.trim() == ''} className='apply-coupon-btn cursor_pointer' onClick={handleApplyCoupon}>Apply</button>
            </div>
           <span className='mi-auto'>{applyCouponErr && "Above coupon code was not found"}</span>
        </div>

        {couponsLoading && !couponsError && <p className={styles.loadingText}>Loading....</p>}

        {!couponsLoading && couponsError && <p className={styles.loadingText}>{couponsError}</p>}

        {coupons && !couponsLoading && <CouponList setApplyCouponErr={setApplyCouponErr} setCouponDetails={setCouponDetails} handleCouponCodeResponse={handleCouponCodeResponse} params={params} parentValues={parentValues} coupons={coupons} setModalOpen={setModalOpen} setDrawerOpen={setDrawerOpen}
          setApplyCouponLoading = {setApplyCouponLoading}
          applyCouponLoading = {applyCouponLoading}
          token={token}
        />}
    </div>

    {/* <Modal isOpen={modalOpen} setIsOpen={setModalOpen}>
      <AppliedCouponView handleCouponCodeResponse={handleCouponCodeResponse} couponDetails={couponDetails} />
    </Modal> */}

    </>
  )
}

export default ApplyCouponView
